import { useState, useEffect } from "react";
import Modal from "react-modal";
import { useSelector,useDispatch } from "react-redux";
// store
import { setSort,setLoading} from "../../configureStore";

Modal.setAppElement("#root");
const SortModal = (props) => {
  const dispatch = useDispatch();
  const [modalIsOpen, setIsOpen] = useState(false);
  const global = useSelector((state) => state.global);
  const searchData = useSelector((state) => state.searchData);
  useEffect(() => {
    if (props.toggleModal) {
      openModal();
    }
  }, [props.toggleModal]);

  function openModal() {
    setIsOpen(true);
    props.callback();
  }

  function closeModal() {
    setIsOpen(false);
  }
  const setDropdownValue = async (value, text) => {
    setIsOpen(false);
    await dispatch(setSort({value,action:"checked"}));
    dispatch(setLoading(true));
  
  };
  return (
    <div>
      <Modal
        portalClassName={"modal-app modal-app--dynamic"}
        overlayClassName={"modal-app__overlay"}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="modal-app__wrapper"
        contentLabel="Sort Modal"
      >
        <div className="modal-app__header">
          <h2 className="modal-app__title">{global.localization.sorting}</h2>
          <button
            className="modal-app__close"
            aria-label="close"
            onClick={closeModal}
          >
            <div className="icon">
              <img src="/assets/images/close.svg" alt="X" />
            </div>
          </button>
        </div>
        <div className="modal-app__cont">
          <div className="sorting-radios">
          {searchData.locationChecked &&
            <label htmlFor="distance">
              <input type="radio" name="sorting" id="distance" onChange={(e)=>setDropdownValue(e.target.value, e.target.textContent)} value="distance"/>
              {global.localization.filterDistance}
            </label> }
            <label htmlFor="az">
              <input type="radio" name="sorting" id="az" onChange={(e)=>setDropdownValue(e.target.value, e.target.textContent)}  value="az"/>
              {global.localization.filterAZ}
            </label>
            <label htmlFor="za">
              <input type="radio" name="sorting" id="za" onChange={(e)=>setDropdownValue(e.target.value, e.target.textContent)} value="za" />
              {global.localization.filterZA}
            </label>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SortModal;
